import { Tooltip } from '@melements/front-components';
import tooltipIcon from 'assets/icons/tooltip.svg';
import React, { Fragment, useContext } from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { Input, LocaleContext } from 'shared';
import {
  combineValidators,
  required as requiredValidator,
  validateEmail,
  validatePhoneNumber,
} from 'utils/formValidators';

import { AccountFormTooltip, CompanyDataRow } from '../../AccountForm.styles';

export const ContactInformation = () => {
  const localeContext = useContext(LocaleContext);

  const required = requiredValidator(localeContext.formatMessage({ id: 'FORM.REQUIRED' }));

  return (
    <Fragment>
      <Field name="contactPerson.name" validate={required}>
        {({ input, meta }: FieldRenderProps<HTMLInputElement>) => (
          <Input
            label={localeContext.formatMessage({ id: 'ACCOUNT.CONTACT-INFORMATION.CONTACT-PERSON' })}
            input={input}
            meta={meta}
            className="acount-form__contact-information-name"
            maxLenght={200}
            charsCounter={true}
          />
        )}
      </Field>
      <CompanyDataRow>
        <Field
          name="contactPerson.phoneNumber"
          validate={combineValidators(
            required,
            validatePhoneNumber(localeContext.formatMessage({ id: 'FORM.INVALID-PHONE-NUMBER' })),
          )}
        >
          {({ input, meta }: FieldRenderProps<HTMLInputElement>) => (
            <Input
              label={localeContext.formatMessage({ id: 'ACCOUNT.CONTACT-INFORMATION.PHONE' })}
              input={input}
              meta={meta}
              className="acount-form__contact-information-phone"
              maxLenght={20}
              charsCounter={true}
            />
          )}
        </Field>
        <Tooltip
          content={
            <AccountFormTooltip>{localeContext.formatMessage({ id: 'FORM.PHONE-NUMBER-TIP' })}</AccountFormTooltip>
          }
        >
          {({ ref }) => <img ref={ref} src={tooltipIcon} alt="" />}
        </Tooltip>
      </CompanyDataRow>
      <Field
        name="contactPerson.email"
        validate={combineValidators(required, validateEmail(localeContext.formatMessage({ id: 'FORM.INVALID-EMAIL' })))}
      >
        {({ input, meta }: FieldRenderProps<HTMLInputElement>) => (
          <Input
            label={localeContext.formatMessage({ id: 'ACCOUNT.CONTACT-INFORMATION.E-MAIL' })}
            input={input}
            meta={meta}
            className="acount-form__contact-information-email"
            maxLenght={100}
            charsCounter={true}
          />
        )}
      </Field>
    </Fragment>
  );
};
